import JsonApi from 'devour-client'

export const jsonApi = new JsonApi({ apiUrl: '/api' })
const singletonModels = ['profile'];

jsonApi.define('user', {}, {collectionPath: 'users'});

jsonApi.define('profile', {
  entered_verification_code: '',
  has_verified_once: false,
  is_verification_code_matching: false,
  phone_number: '',
  request_code: false,
  texts_disabled: false,
  time_zone: ''
}, {
  collectionPath: 'hugster/profiles'
});

jsonApi.define('contact', {
  formatted_phone_number: '',
  name: '',
  phone_number: ''
}, {
  collectionPath: 'hugster/contacts'
});

jsonApi.define('item', {
  detail_page_url: '',
  medium_image_url: '',
  title: ''
}, {
  collectionPath: 'prontissimo/items'
});

const token = document.querySelector('meta[name="csrf-token"]').content;
jsonApi.headers['x-csrf-token'] = token;

const singletonRequestMiddleware = {
  name: 'fix-singleton-request',
  req: (payload) => {
    const req = payload.req;
    if ((payload.req.method == 'PATCH' || payload.req.method == 'PUT')
         && singletonModels.includes(payload.req.model)) {
      // Chop off id from URL
      req.url = req.url.substring(0, req.url.lastIndexOf('/'));
    }
    return payload
  }
}

jsonApi.insertMiddlewareBefore('axios-request', singletonRequestMiddleware);
